import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const Title = () => {
    const { t } = useGranite();

    return (
        <h3 className={cn("tw:mr-4")}>{t("search.results.title.products")}</h3>
    );
};

export { Title };
